<cass-core-toolbar></cass-core-toolbar>
<ng-container *ngIf="(callingOut$ | async)">
	<div class="container">
		<cass-indeterminate-circular-progress-indicator></cass-indeterminate-circular-progress-indicator>
		<div class="loading-text">Verifying token ... </div>
	</div>
</ng-container>
